<template>
    <Head>
        <title>{{ article.title }}</title>
        <meta
            name="description"
            :content="article.content.substring(0, 120) + '...'"
        />
        <meta
            name="keywords"
            content="Truck Driving Jobs,Truck Driving Jobs Near Me"
        />
        <meta property="og:title" :content="article.title" />
        <meta property="og:site_name" content="opencdljobs.com" />
        <meta
            property="og:description"
            :content="article.content.substring(0, 120) + '...'"
        />
        <meta property="og:type" content="article" />
        <meta
            property="og:url"
            :content="`https://opencdljobs.com/blog/article/${article.slug}`"
        />
        <meta
            property="og:image"
            content="https://opencdljobs.com/images/opencdljobs.png"
        />
    </Head>
    <div class="p-4">
        <main
            class="pt-8 pb-16 lg:pt-16 lg:pb-24 bg-white dark:bg-gray-900 antialiased font-arial"
        >
            <div class="">
                <article
                    class="mx-auto w-full max-w-6xl format format-sm sm:format-base lg:format-lg format-blue dark:format-invert"
                >
                    <header class="mb-4 lg:mb-6 not-format">
                        <address class="flex items-center mb-6 not-italic">
                            <div
                                class="inline-flex items-center mr-3 text-sm text-gray-900 dark:text-white"
                            >
                                <img
                                    class="mr-2 w-16 h-16 rounded-full border"
                                    :src="
                                        'https://eu.ui-avatars.com/api/?name=' +
                                        article.author.name +
                                        '&size=250'
                                    "
                                    :alt="article.author.name"
                                />
                                <div>
                                    <h3
                                        class="text-xl font-semibold text-gray-500 dark:text-white"
                                    >
                                        {{ article.author.name }}
                                    </h3>
                                    <div>
                                        <small>Posted on - </small>

                                        <small
                                            class="text-gray-500 dark:text-gray-400"
                                        >
                                            <time
                                                pubdate
                                                :datetime="article.published_at"
                                                :title="article.published_at"
                                                >{{
                                                    publishedAt(
                                                        article.published_at
                                                    )
                                                }}</time
                                            >
                                        </small>
                                        <div>
                                            <small
                                                class="tracking-wider mb-4 bg-gray-50 px-4 py-1 border rounded"
                                                >#
                                                {{
                                                    article.article_category
                                                        ?.name
                                                }}</small
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </address>
                        <div class="flex items-center space-x-1 py-3">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-4 h-4"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>

                            <small>{{ article.reading_time_estimation }}</small>
                        </div>
                        <h1
                            class="mb-4 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white"
                        >
                            {{ article.title }}
                        </h1>
                    </header>

                    <div
                        v-if="video"
                        class="mt-4 relative rounded-md overflow-hidden"
                        style="padding-top: 56.25%"
                    >
                        <iframe
                            class="absolute inset-0 w-full h-full"
                            :src="`https://www.youtube.com/embed/${video}`"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>

                    <div
                        v-if="screeenpalVideo"
                        class="mt-4 relative rounded-md overflow-hidden"
                        style="padding-top: 56.25%"
                    >
                        <iframe
                            class="absolute inset-0 w-full h-full"
                            :src="`${screeenpalVideo}`"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div class="tip-tap text-lg pt-10" v-html="article.content" />
                </article>
            </div>
        </main>
    </div>
</template>

<script setup>
import { Head } from "@inertiajs/inertia-vue3";
import { DateTime } from "luxon";
import { computed } from "vue";

const props = defineProps({
    article: Object,
});

const { article } = props;

function publishedAt(published_at) {
    return DateTime.fromISO(published_at).toLocaleString(DateTime.DATE_MED);
}
const video = computed(() => {
    const url = article.video_url;

    if (!url) {
        return null;
    }

    if (url.includes("?v=")) {
        return url.split("?v=").at(-1);
    } else if (url.includes("youtu.be/")) {
        return url.split("youtu.be/").at(-1);
    }

    return null;
});

const screeenpalVideo = computed(() => {
    const url = article.video_url;

    if (!url) {
        return null;
    }

    if (url.includes("screenpal.com/watch")) {
        return url;
    }
    return null;
});
</script>

<style scoped>
.tip-tap {
    :deep(& h1) {
        font-size: 24px;
        font-weight: bold;
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
    }

    :deep(& h2) {
        font-size: 18px;
        font-weight: bold;
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
    }

    :deep(& h3) {
        font-size: 16px;
        font-weight: bold;
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
    }

    :deep(& h4) {
        font-size: 14px;
        font-weight: bold;
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
    }
}
</style>
